import React from 'react';
import { Link } from 'react-router-dom';

import { store } from '../../../';
import {
  getTextFilter,
  getDomainFilter,
  getDaterangeFilter
} from './filterCreators';

export function getAccessor(
  fieldDefinition,
  attributeFormatter,
  api,
  fieldInfos
) {
  if (!attributeFormatter) {
    return d => getValue(d, fieldDefinition.name);
  }

  return d => {
    const value = getValue(d, fieldDefinition.name);
    const data = attributeFormatter(
      fieldDefinition.name,
      value,
      api,
      fieldInfos
    );
    return data.value;
  };
}

export function getCellDef(fieldDefinition, attributeFormatter, fieldInfos) {
  const field = fieldDefinition.name;

  switch (fieldDefinition.type) {
    default:
      // If the field type was not defined, or is not a known
      // value, don't apply any formatting
      return field;
  }
}

export function getActionsDef(actions) {
  return d => {
    return actions.map(action => {
      let id;
      let base;
      if (d.original.IrwinID) {
        id = d.original.IrwinID;
        base = 'incidents';
      } else {
        id = d.original.IrwinRID;
        base = 'resources';
      }

      return (
        <Link key={id} to={`/${base}/${id}${window.location.search}`}>
          {action}
        </Link>
      );
    });
  };
}

export function getFilterComponent(def, api, fieldFilter) {
  // add logic for unique resource request history datagrid, where fields from resource/experience/requests
  // have been combined
  if (def.domain && def.domain.type === 'coded-value' && api !== 'resource.request') {
    return getDomainFilter(def.name, store.getState()[api].fields, fieldFilter);
  }
  if (def.domain && def.domain.type === 'coded-value') {
    return getDomainFilter(def.name, store.getState().resource.request.fields, fieldFilter);
  }
  switch (def.type) {
    case 'date':
    case 'esriFieldTypeDate':
      return getDaterangeFilter(def.name, fieldFilter);
    default:
      return getTextFilter(def.name, fieldFilter);
  }
}

//
// Private Methods
//

function getValue(data, fieldName) {
  return data[fieldName];
}



// WEBPACK FOOTER //
// ./src/components/common/DataGrid/gridHelpers.js